import React from 'react';
import styled from 'styled-components';
import { calc4k } from '../utilities';
import { colors, gradient, padding } from '../GlobalStyle';

export default function( { image, supertitle, title, subtitle, desc, note, time, active, vignette } ) {
    return (
        <HeroSlide image={ image } active={ active } vignette={vignette}>
            <Content>
                { time ? (
                    <Time>
                        { time }
                    </Time>
                ) : null }
                { supertitle ? (
                    <Supertitle>
                        { supertitle }
                    </Supertitle>
                ) : null }
                { title ? (
                    <Title>
                        { title }
                    </Title>
                ) : null }
                { subtitle ? (
                    <Subtitle>
                        { subtitle }
                    </Subtitle>
                ) : null }
                { desc ? (
                    <Description>
                        { desc }
                    </Description>
                ) : null }
                { note ? (
                    <Note>
                        { note }
                    </Note>
                ) : null }
            </Content>
        </HeroSlide>
    );
}

const HeroSlide = styled.article`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: ${ p => {
        if( p.active ) {
            return 'opacity 600ms ease';
        } else {
            return 'opacity 600ms 200ms ease';
        }    
    } };
    opacity: ${ p => p.active ? 1 : 0 };   
    background-image: url(${ p => p.image });
    background-size: cover;
    display: flex;
    align-items: center;
    padding: 0 ${padding.side};
    padding-top: ${calc4k(200)};
    overflow: hidden;
    
    &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 200%;
        height: 200%;
        background: ${gradient.blackCircle};
        opacity: ${ p => p.vignette || p.vignette === 0 ? p.vignette/100 : 0.75 };
    }
`;

const Content = styled.div`
    position: relative;
    z-index: 1;
    max-width: ${calc4k(1245)};
`;

const Supertitle = styled.div`
    font-size: ${ calc4k( 45 ) };
    margin-bottom: ${ calc4k( 55 ) };
    font-weight: 500;
    color: ${ colors.grey };
    text-transform: uppercase;
`;

const Time = styled.div`
    color: white;
`;

const Title = styled.h2`
    font-size: ${ calc4k( 125 ) };
    margin-bottom: ${ calc4k( 62.5 ) };
    font-weight: 500;
`;

const Subtitle = styled.div`
    font-size: ${ calc4k( 45 ) };
`;

const Description = styled.p`
    font-size: ${ calc4k( 60 ) };
    margin-bottom: ${ calc4k( 70 ) };
`;

const Note = styled.div`
    font-size: ${ calc4k( 45 ) };
    color: ${ colors.gold };
    font-weight: 500;
`;